import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { SystemSetting } from 'actions/actionTypes';
import * as actions from 'actions/common/systemSetting';

import { callSystemSettingList } from 'network/apis/common/systemSetting';

function* loadSystemSettingListRequestSaga() {
    try {
        const systemSetting = yield select((state) => state.systemSetting);

        const responses = yield all(systemSetting.settingGroups.map((settingGroup) => call(callSystemSettingList, settingGroup)));

        yield put(actions.loadSystemSettingListRequestSuccess(responses));
    } catch (error) {
        yield put(actions.loadSystemSettingListRequestFailure(error.message));
    }
}

// Sign-In Sagas
export default function* root() {
    yield all([takeLatest(SystemSetting.LOAD_SYSTEM_SETTING_LIST_REQUEST, loadSystemSettingListRequestSaga)]);
}
